export const validateFiled = (content) => {
  if (content.trim() === "") {
		return false;
  }
	return true;
};

export const validateEmail = (content) => {
  if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(content)) {
    return true;
  }
  return false;
};
